import { ActionBrick, BrickContext, registerBrick } from 'olympe';

type Inputs = [string: string];

type Outputs = [
  forwardEvent: () => void,
  setIsTrue: () => void,
  setIsFalse: () => void
];

export default class IsStringOneOrZero extends ActionBrick {
  update(
    $: BrickContext,
    [string]: Inputs,
    [forwardEvent, setIsTrue, setIsFalse]: Outputs
  ) {
    if (+string) {
      setIsTrue();
    } else {
      setIsFalse();
    }

    forwardEvent();
  }
}

registerBrick('018a1d5dd3d8e6da1af5', IsStringOneOrZero);
